/* eslint-disable camelcase */
export default {
	the_withdrawal_the_document_will_be_in_draft_status: '撤回后单据将为草稿状态, 是否继续?',
	prompt: '提示',
	determine: '确定',
	cancel: '取消',
	withdraw_successfully: '撤回成功',
	please_choose: '请选择',
	no_more_than_a_week: '不能超过一周',
	deleted: '已删除',
	draft: '草稿',
	approval: '审批',
	relateApprovalAudit: '相关审批人',
	vendorConfirm: '供应商确认',
	purchaserConfirm: '采购确认',
	priceLibrary: '已进价格库',
	leaderAudit: '直属Leader审批',
	centerChargerAudit: '中心负责人审批',
	processing: '系统处理中',
	businessFinancialAudit: '业务线财管审批',
	businessDeptHeadAudit: '业务部门负责人审批',
	coopDeptHeadAudit: '产业生态合作部负责人审批',
	audited: '审批完成',
	cancelled: '已取消',
	effective: '已完成',
	terminated: '已终止',
	stopped: '已中止',
	pendingAcceptance: '待验收',
	acceptance: '已验收',
	vendorAlreadyConfirm: '供应商已确认',
	finished: '已完成',
	enquirying: '询价中',
	approved: '审核通过',
	cancelled_s: '已作废',
	quoted: '已报价',
	terminated_s: '报价作废',
	priceLibrary_s: '已生成价格库',
	priceLibrarying: '已打开报价',
	opened: '打开报价',
	Demand_order_number: '需求单编号',
	Decision_title: '决策标题',
	Creation_time: '创建时间',
	status: '状态',
	Decision_type: '决策类型',
	Decision_making_department: '决策部门',
	Manager: '经办人',
	Effective_time_of_decision: '决策有效时间',
	Inquire: '查询',
	Empty: '清空',
	decision_number: '决策编号',
	decision_title: '决策标题',
	currency: '币种',
	applicant: '申请人',
	application_department: '申请部门',
	remarks: '备注',
	final_purchase_amount: '最终采购金额',
	Decision_amount: '决策金额',
	availableAmount: '决策单余额',
	Final_purchase_amount: '最终采购金额',
	Cost_Center: '成本中心',
	product: '产品',
	Budget_account: '预算科目',
	founder: '创建人',
	Please_enter_content: '请输入内容',
	Final_purchase_amount_CNY: '最终采购金额(CNY)',
	Relevant_approvers: '相关审批人',
	Effective_date_of_decision: '决策有效日期',
	Associate_RFI: '关联RFI',
	category: '类别',
	Associated_inquiry_number: '关联询价单号',
	Associated_inquiry_sheet: '关联询价单',
	Project_Area: '项目区域',
	Project_category: '项目类别',
	Related_requirements: '采购需求单号',
	Terms_payment: '付款条件',
	Related_project: '关联立项',
	Share_control_method: '份额控制方式',
	Decision_level: '决策层级',
	Whether_the_annual_framework_project: '是否年框架项目',
	Associated_Decision_Order_Number: '关联决策单号',
	Exchange_rate_type: '汇率类型',
	Exchange_rate_date: '汇率日期',
	Exchange_rate: '汇率',
	Decision_content: '决策内容',
	operating: '操作',
	processing_steps: '操作步骤',
	Decision_point: '决策点',
	meeting_time: '会议时间',
	Meeting_place: '会议地点',
	Attendees: '出席人员',
	Internal_control_staff: '内控人员',
	Generate_template: '生成模板',
	Minutes_of_the_meeting: '会议纪要',
	save: '保存',
	submit_for_approval: '提交审批',
	submit: '提交',
	delete: '删除',
	withdraw: '撤回',
	voidButton: '作废',
	return: '返回',
	initiateAchange: '发起变更',
	supplier: '供应商',
	Share_ratio: '份额比例',
	amount: '金额',
	Serial_number: '序号',
	Handler: '处理人',
	post: '岗位',
	opinion: '意见',
	Processing_time: '处理时间',
	time_consuming: '耗时',
	Comment: '评论',
	queryCondition: '查询条件',
	basic_information: '基本信息',
	business_scenario: '业务场景',
	transaction_department: '经办部门',
	transaction_center: '经办中心',
	transaction_group: '经办小组',
	total_contract_price: '合同期总价',
	item_amount: '项目金额',
	attachmentInfo: '附件信息',
	approval_history: '审批历史记录',
	current_handler: '当前处理人',
	business_demand_name: '业务需求名称',
	business_demand_description: '业务需求说明',
	decision_action: '需求动作',
	decision_source: '需求来源',
	business_demand_budget: '业务需求预算',
	business_demand_detail: '业务需求明细'
};
